import { Injectable, computed, inject } from '@angular/core';
import { catchError, first, map, mergeMap, of } from 'rxjs';
import { EffectsBase, mergeTwoObjects } from 'clicklease-ui-elements';
import { RoseService } from './../../services';
import {
    LoadPersonalInfoFormAction,
    PersonalInfoFormSelector,
    PersonalInformationIdSelector,
    PersonalWritableInformationSelector,
    SetSubmittingPersonalInfoFormAction,
    SetSubmittingPersonalInfoFormErrorAction,
} from './../../ngrx';

@Injectable()
export class PersonalInfoEffectsService extends EffectsBase {
    readonly #roseService = inject(RoseService);
    readonly #personalInfo = this.store.selectSignal(
        PersonalWritableInformationSelector
    );
    readonly #personalFormInfo = this.store.selectSignal(
        PersonalInfoFormSelector
    );
    readonly #roseId = this.store.selectSignal(PersonalInformationIdSelector);
    readonly #newPersonalInfo = computed(() =>
        mergeTwoObjects(this.#personalInfo(), this.#personalFormInfo())
    );

    public readonly submitPersonalInfoForm = this.createEffect(() =>
        this.actions.pipe(
            this.ofType(LoadPersonalInfoFormAction),
            mergeMap(() => this.updatePersonalInfo())
        )
    );

    private updatePersonalInfo() {
        return this.#roseService
            .updatePersonalInfo(this.#roseId(), this.#newPersonalInfo())
            .pipe(
                map(() => SetSubmittingPersonalInfoFormAction()),
                catchError(() => of(SetSubmittingPersonalInfoFormErrorAction())),
                first()
            );
    }
}
